import { FormLabel } from "@chakra-ui/react";

import { RanaFileIcon } from "@/lib/rana-file-data-type";

import { CompleteFile, Layer } from "../../../";

export const LegendLabel = ({ layer, file }: { layer: Layer; file: CompleteFile }) => {
  return (
    <FormLabel display="flex" alignItems="center" mb={1}>
      <RanaFileIcon fileOrDirectory={file.file} />
      {layer.name}
    </FormLabel>
  );
};
